import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import RoutinePopup from "../Reusable/Routine/Popup/RoutinePopup";

import {
 
  Typography,


} from "@mui/material";

import { sections, sectionPaths } from '../../constants/sectionDatapeople';
import ActivityBar from "../Reusable/ActivityBar/ActivityBar";


import GlobalPoliciesFileViewPopup from '../Reusable/Popup/GlobalPoliciesFileViewPopup'
import GPAdminFileViewPopup from '../Reusable/Popup/GPAdminFileViewPopup'
import { apiService } from "../../api/apiService";
import RoutineTabs from "../Reusable/utils/RoutineTabs";
import ChangeManagementPopup from "../Reusable/Routine/Popup/ChangeManagementPopup";
import ChangeManagementTabs from "../Reusable/utils/ChangeManagementTabs";
import { getFileImagePath } from "../Reusable/utils/fileUtils";
import SectionSliderPeople from "../Reusable/SectionSlider/SectionSliderPeople";
import LearningDevelopmentPopup from "../Reusable/Routine/Popup/LearningDevelopmentPopup";
import { useMsal } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';


interface LocationState {
  management?: string;
  id: any;
  function_l1: any;
  file_name: string;
  created_at: any;
  updated_at: any;
  updated_by: any;
  onClick: (id: any, file_name: string, function_l1: any, created_at: any, updated_at: any, updated_by: any) => void;
  status: any;
  reason_to_approve: any;
  reason_to_revert: any;
}
interface LearningDevelopmentUploadProps {

  isAdmin?: boolean;
  isManager?: boolean;
  

}

const verticalTabs = [
  { label: "Buddy Program", value: "a" },
  { label: "Training Plan", value: "b" },
  { label: "Training feedback", value: "c" },
  { label: "Training Calendar", value: "d" },
  { label: "Learning Effectiveness", value: "e" },
];

const getFileQuestions = (tabValue: string) => {

  switch (tabValue) {
    case "a":
      return "Question : A buddy process is in place to support the new hires.";
    case "b":
      return "Question : All new hires and job movers have a training plan that includes functional and leadership skills, as well as problem-solving methodologies (eg White Belt), to help them excel in their new role.";
    case "c":
      return "Question : Leaders have feedback conversations with job movers and new hires, with action plans in place to address gaps and enhance the learning experience.";
    case "d":
      return "Question : The Center has a training calendar that includes functional and leadership skills based on Learning Needs' Analysis, and relevant Global GBS People guidelines";
    case "e":
      return "Question : The local People team measures the effectiveness of learning initiatives by tracking feedback from leaders and participants, as well as the evolution of relevant business KPIs";
    default:
      return null;
  }
};

const LearningDevelopmentUpload: React.FC<LearningDevelopmentUploadProps> = ({ isAdmin, isManager }) => {
  const { instance } = useMsal();
  const navigate = useNavigate();
  const [tabValue, setTabValue] = useState("1");
  const [verticalTabValue, setVerticalTabValue] = useState("a");
  const [openUpload, setOpenUpload] = useState(false);
  const [open, setOpen] = useState(false);
  const [routineData, setRoutineData] = useState<any[]>([]);



  // const locationState = location.state as LocationState | undefined;
  // const management = locationState?.management || "Default Location Name";
  const management = localStorage.getItem("management") || "Default Location Name";
  const [currentPage, setCurrentPage] = useState(1);
  const [filterValue, setFilterValue] = useState('');
  const [files, setFiles] = useState<LocationState[]>([]);


  const [isPopupOpen, setPopupOpen] = useState(false);

  const [page, setPage] = useState(1);
  const itemsPerPage = 3;
  const handleChangePage = (event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);
  };

  const startIndex = (page - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  // const paginatedData = routineData.slice(startIndex, endIndex);

  // Tab Status Logic
  const tabStatuses: { label: string; value: 'All' | 'Pending' | 'Approved' | 'Reverted'; apiStatus: string | null }[] = [
    { label: 'All', value: 'All', apiStatus: null }, // `null` means no filtering (include all statuses)
    { label: 'Pending', value: 'Pending', apiStatus: 'Pending' },
    { label: 'Approved', value: 'Approved', apiStatus: 'Approved' },
    { label: 'Reverted', value: 'Reverted', apiStatus: 'Reverted' },
  ];
  const selectedStatus = tabStatuses.find(tab => String(tabStatuses.indexOf(tab) + 1) === tabValue)?.value;

  // Filter routineData based on the selected tab status
  const filteredRoutineData = selectedStatus === "All"
    ? routineData
    : routineData.filter(item => item.status === selectedStatus);

  const paginatedData = filteredRoutineData.slice(startIndex, endIndex);

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleClosePopup = () => {
    setPopupOpen(false);
  };

  const fetchRoutineData = async () => {
    setIsLoading(true);
    try {
      const response = await apiService(
        "/people/filter_learning_n_development",
        "GET",
        {
          management: management,
          section_name: verticalTabs.find((tab) => tab.value === verticalTabValue)?.label,
        },
        undefined, 
        instance as PublicClientApplication
      );

      if (response.data) {
        setRoutineData(response.data); // Update routineData
        setFiles(response.data); // Sync files with the API response
      }
    } catch (error) {
      console.error("Error fetching routine data:", error);

      // Set routineData to null on API failure
      setRoutineData([]);

      // Update the error state
      if (error instanceof Error) {
        setError(error.message || "An error occurred");
      } else {
        setError("An error occurred");
      }

      // Check if the error status is 401 and redirect to /login
      if (error instanceof Error && (error as any).response && (error as any).response.status === 401) {
        navigate('/login');
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
  
    fetchRoutineData();
  }, [verticalTabValue]);


  // const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
  //   setTabValue(newValue);
  // };

  const handleVerticalTabChange = (event: React.SyntheticEvent, newValue: string) => {
    setVerticalTabValue(newValue);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

const [selectedFile, setSelectedFile] = useState<{ id: any; file_name: string, function_l1: any, created_at: any, status: any, reason_to_approve: any, reason_to_revert: any, updated_at: any, updated_by: any } | null>(null);
console.log('selectedFile', selectedFile)

  const handleViewClick = (id: any, file_name: string, function_l1: any, created_at: any, updated_at: any, updated_by: any, status: any, reason_to_approve: any, reason_to_revert: any) => {
    setPopupOpen(true);
    setSelectedFile({ id, file_name, function_l1, created_at, status, reason_to_approve, reason_to_revert, updated_at, updated_by });
  };


  const breadcrumbs = [
   <Link key="1" to="/">
         Home
       </Link>,
       <Link key="2" to="/operations/management">
         Evidence Upload
       </Link>,
         <Link key="3" to="/operations/management/">
         People
       </Link>,
    <Typography key="4" color="#000" >
      {management}
    </Typography>,
  ];


  const handleTabChange = (_: React.SyntheticEvent, newValue: string) => {
    console.log("Tab changed to:", newValue);
    setTabValue(newValue);
  };



  const counts = {
    All: files.length,
    Pending: files.filter((file) => file.status === 'Pending').length,
    Approved: files.filter((file) => file.status === 'Approved').length,
    Reverted: files.filter((file) => file.status === 'Reverted').length,
  };

 


  return (
    <>
      {/* Activity Bar and Section Slider */}
      <ActivityBar breadcrumbs={breadcrumbs} />
      <SectionSliderPeople
        sections={sections}
        sectionPaths={sectionPaths}
        highlightSection={'Learning & Development'}
        highlightColor="#D7A833"
        defaultColor="#666"
      />


      <ChangeManagementTabs
        tabValue={tabValue}
        handleTabChange={handleTabChange}
        tabStatuses={tabStatuses}
        counts={counts}
        verticalTabValue={verticalTabValue}
        question={getFileQuestions(verticalTabValue)}        
        verticalTabs={verticalTabs}
        isLoading={isLoading}
        filteredRoutineData={filteredRoutineData}
        paginatedData={paginatedData}
        routineData={routineData}
        itemsPerPage={itemsPerPage}
        handleChangePage={handleChangePage}
        handleViewClick={handleViewClick}
        setOpenUpload={setOpenUpload}
        getFileImagePath={getFileImagePath}
        handleVerticalTabChange={handleVerticalTabChange}
        isMcrTab={true}
      />


      {/* Upload form section */}
      <LearningDevelopmentPopup openUpload={openUpload} setOpenUpload={setOpenUpload} management={management} verticalTabValue={verticalTabs.find(tab => tab.value === verticalTabValue)?.label} verticalTabValueTitle={verticalTabValue} onSuccess={fetchRoutineData}/>

      {/* File View Popup */}
      {isPopupOpen && selectedFile && (
        <>
          {
            isManager && (
              <GlobalPoliciesFileViewPopup
                onClose={handleClosePopup}
                open={true}
                name={selectedFile.file_name}
                id={selectedFile.id}
                // functionl1={selectedFile.function_l1}
                date={selectedFile.created_at}
                updatedBy={selectedFile.updated_by}
                sectionTitle={verticalTabs.find(tab => tab.value === verticalTabValue)?.label || ''}
                // userDetail={true}
                apiPath={`/people/learning_n_development/${selectedFile.id}`} // Pass the API path for file details
                

              />
            )
          }


          {isAdmin && (
            <GPAdminFileViewPopup
              onClose={handleClosePopup}
              open={true}
              name={selectedFile.file_name}
              id={selectedFile.id}
              // functionl1={selectedFile.function_l1}
              date={selectedFile.created_at}
              updatedBy={selectedFile.updated_by}
              status={selectedFile.status}
              reason_to_approve={selectedFile.reason_to_approve}
              reason_to_revert={selectedFile.reason_to_revert}
              sectionTitle={verticalTabs.find(tab => tab.value === verticalTabValue)?.label || ''}
              apiPath={`/people/learning_n_development/${selectedFile.id}`} // Pass the API path for file details
              statusApiPath="/people/learning_n_development_status" // Pass the API path for status updates
            />
          )}
        </>
      )}

    </>
  );
};

export default LearningDevelopmentUpload;